import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import DateTimeSelector from '#/trip-planner/components/DateTimeSelector';
import DetailViewLayout from '#/components/DetailViewLayout';
import DetailNavHeader from '#/shared/components/DetailNavHeader';
import SEO from '#/shared/components/SEO';
import useCurrentQuery from '#/trip-planner/hooks/useCurrentQuery';
import useNavigate from '#/shared/hooks/useNavigate';
import ROUTES from '#/constants/routes';
import useViewMapControls from '#/map/hooks/useViewMapControls';
import useDepartNow from '#/trip-planner/hooks/useDepartNow';
import {
  ORIGIN_LOCATION_TYPE,
  DESTINATION_LOCATION_TYPE,
  DEPARTURE_OPTION_SELECTOR,
} from '#/shared/constants';
import { setTripTimestamp } from '#/trip-planner/slice';
import otpUiConfig from '#/otp-ui-config';

function TripDateTimeSelectorContainer() {
  const { navigate, generateNavigateBack, generateNavigateClose } =
    useNavigate();

  useDepartNow();
  const { dateFormat } = otpUiConfig.dateTime;

  const saveSettings = () => {
    navigate(ROUTES.planner);
  };
  const planTrip = () => {
    navigate(ROUTES.trip);
  };
  const { modeSelectorViewOpened, viewClosed } = useViewMapControls();

  useEffect(() => {
    modeSelectorViewOpened();
    return viewClosed;
  }, [modeSelectorViewOpened, viewClosed]);

  const { currentQuery, setCurrentQueryParam } = useCurrentQuery();

  const onDateTimeQueryParamChange = queryParams => {
    Object.entries(queryParams).map(([k, v]) => setCurrentQueryParam(k, v));
  };

  const dispatch = useDispatch();

  const onTripDatetimeChange = nextDateTime =>
    dispatch(setTripTimestamp(nextDateTime?.getTime()));
  const { tripTimestamp } = useSelector(s => s.tripPlanner);

  return (
    <>
      <SEO metadataId="plannerForms" />
      <DetailViewLayout
        top={
          <DetailNavHeader
            onBack={generateNavigateBack([], ROUTES.planner)}
            onClose={generateNavigateClose([ROUTES.all])}
            content={<FormattedMessage id="planner.timesettingstitle" />}
          />
        }
        bottom={
          <DateTimeSelector
            initialTimestamp={tripTimestamp}
            departureOption={currentQuery[DEPARTURE_OPTION_SELECTOR]}
            originAndDestinationSet={
              !!currentQuery[ORIGIN_LOCATION_TYPE] &&
              !!currentQuery[DESTINATION_LOCATION_TYPE]
            }
            dateFormat={dateFormat}
            onTripDatetimeChange={onTripDatetimeChange}
            onQueryParamChange={onDateTimeQueryParamChange}
            onPlanTrip={planTrip}
            onSaveSettings={saveSettings}
          />
        }
        hasInverseBackground
      />
    </>
  );
}

export default TripDateTimeSelectorContainer;
